import { useRef } from 'react';
import { useScaledFontSize } from '@shared/hooks/useScaledFontSize';
import { useNeedsContrastBorder } from '@shared/hooks/useNeedsContrastBorder';
import type { Line } from '@shared/models/line';
import styles from './Line.module.scss';
import classNames from 'classnames';

interface LineProps {
  line: Line;
  size: 'small' | 'medium' | 'large';
}

export default function Line({ line, size }: LineProps) {
  const lineNameRef = useRef<HTMLDivElement>(null);
  useScaledFontSize(lineNameRef);
  const needsBorder = useNeedsContrastBorder(lineNameRef, line.backgroundColor);

  return (
    <div className={classNames(styles.line, styles[`line--${size}`])}>
      <div
        ref={lineNameRef}
        className={styles.line__name}
        style={{
          color: line.textColor,
          backgroundColor: line.backgroundColor,
          borderColor: needsBorder ? line.textColor : line.backgroundColor,
        }}
        aria-hidden="true"
      >
        {line.shortName}
      </div>
      <span className="sr-only">{`Linje ${line.shortName}`}</span>
    </div>
  );
}
